import {
  Button,
  Checkbox,
  CircularProgress,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Typography,
} from '@mui/material';
import { StyledTextField } from '../../../components/StyledComponent/StyledComponent';
import './SignIn.scss';
import { useEffect, useState } from 'react';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { postRequest } from '../../../axios/axios';
import { toast } from 'react-toastify';
import { useFormik } from 'formik';
import { signInSchema } from '../LoginSchema';
import {
  reset,
  saveEmail,
  handleIsEmailValid,
  handleForgetPassword,
  handleIsCallFromForgetPass,
  saveEmailValidate,
  updateRole,
} from '../LoginSlice';
import { useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../../../config/authConfig';
import TickIcon from '../../../assets/tickIcon.svg';

const SignIn = (props) => {
  const { handleSetPasswordComponent, handleUserEmail } = props;
  window.localStorage.removeItem('fileClaimWithoutJob');
  const navigate = useNavigate();
  const { instance } = useMsal();
  const dispatch = useDispatch();
  const [userEmail, setUserEmail] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isDisabled, setIsDisables] = useState(true);
  const [onceClicked, setOnceClicked] = useState(false);
  const [alreadyExit, setAlreadyExit] = useState(false);
  const [isEmailVerified, setIsEmailVerified] = useState(false);
  const [loader, setLoader] = useState(false);
  const [isChecked, setIsChecked] = useState(false);

  const handleOnChange = () => {
    setIsChecked((prev) => !prev);
  };

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  let organization = localStorage.getItem('organisationType');

  useEffect(() => {
    if (organization === 'opw') {
      navigate('/Dashboard');
    } else if (organization === 'servicer') {
      navigate('/allJobs');
    }
  }, []);

  let defaultValue = {
    email: '',
    password: '',
    isEmailVerified: false,
  };
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: defaultValue,
    validationSchema: signInSchema,
    onSubmit: () => handleAccountInfo(),
  });
  const { values, errors, setFieldValue, handleSubmit, handleBlur, touched } = formik;
  const userLoginRequest = async (reqBody = {}) => {
    const res = await postRequest('/api/users/login', reqBody, 'sdLogin');
    return res;
  };
  const handleUserLogin = async () => {
    const toastId = toast.loading('Loading...');
    try {
      const { email = '', password = '' } = values;
      if (Object.keys(errors)?.length > 0) {
        return setOnceClicked(false);
      }
      if (email?.length === 0 || password === 0) {
        return setOnceClicked(false);
      }
      const reqBody = {
        email: email,
        password: password,
        provider: 'OPW',
      };

      const res = await userLoginRequest(reqBody);
      const { isSuccess, statusCode, data } = res?.data || {};
      const isValidStatus = isSuccess && statusCode === 200;
      if (isValidStatus && data === 'Incorrect Password.') {
        toast.error('Incorrect Password');
        return setOnceClicked(false);
      } else if (isValidStatus && data === 'User not found') {
        toast.error('User not found');
        return setOnceClicked(false);
      } else if (isValidStatus) {
        handleStoreLoginInfo(res);
      } else {
        toast.error(res.data.error || 'Something Went Wrong');
      }
    } catch (error) {
    } finally {
      toast.dismiss(toastId);
      setOnceClicked(false);
    }
  };
  const handleStoreLoginInfo = (res) => {
    toast.success('Login successfully');
    const { token = '', keyCloakToken = '' } = res?.data?.data || {};
    const { organisationType = '', organisationName = '' } = res?.data?.data?.user?.organisation || {};
    const { roleType = '', organisation = {} } = res?.data?.data?.user || {};
    dispatch(updateRole(roleType));
    sessionStorage.setItem('EligibleFileClaimWithoutJob', 0);
    localStorage.setItem('loginToken', token);
    localStorage.setItem('organisationType', organisationType);
    localStorage.setItem('organisationName', organisationName);
    localStorage.setItem('keyCloakLoginToken', keyCloakToken);

    if (!organisation) return;
    if (organisationType === 'servicer') {
      return navigate('/allJobs', { state: { activeIndex: '2' } });
    } else if (organisationType === 'opw') {
      return navigate('/Dashboard');
    } else {
      return navigate('/AccessDenied');
    }
  };

  const handleAccountInfo = async () => {
    try {
      if (userEmail?.length === 0 || values?.email?.length === 0) {
        return setLoader(false);
      }
      setOnceClicked(true);
      setLoader(true);
      if (isDisabled) {
        const reqBody = {
          email: `${userEmail}`,
        };
        const res = await postRequest('/api/email/validate', reqBody, 'sdLogin');
        const { isEmailExist, isPasswordExist } = res?.data?.data || {};
        if (res.data.isSuccess) {
          if (isEmailExist && !isPasswordExist) {
            dispatch(handleIsEmailValid(true));
            dispatch(saveEmailValidate(userEmail));
            setOnceClicked(false);

            if (handleSetPasswordComponent) {
              handleSetPasswordComponent(true);
              setOnceClicked(false);
            }
          }
          if (isEmailExist && isPasswordExist) {
            setIsDisables(false);
            setOnceClicked(false);
            formik.setFieldValue('isEmailVerified', true);
            setAlreadyExit(true);
            setIsEmailVerified(true);

            dispatch(saveEmailValidate(userEmail));
          }
          if (!isEmailExist && !isPasswordExist) {
            toast.error('User with this Email does not Exist');
            setOnceClicked(false);
            setLoader(false);
          }
        } else {
          setOnceClicked(false);
          setLoader(false);
          toast.error(res?.data?.message);
        }
      } else {
        handleUserLogin();
      }
    } catch (error) {}
  };

  const handleEmailChange = (e) => {
    const { value } = e.target;
    setLoader(false);
    setFieldValue('email', value);
    dispatch(saveEmail(value));
    setUserEmail(value);

    if (handleUserEmail) {
      handleUserEmail(value);
    }
    setIsEmailVerified(false);
    if (!isDisabled) {
      setIsDisables(true);
    }
    setIsDisables(true);
  };
  const handleOnCLickOnForgetPassword = () => {
    dispatch(reset());
    dispatch(handleForgetPassword(true));
    dispatch(handleIsCallFromForgetPass(true));
  };

  const microsoftLogin = async () => {
    try {
      // Initiate the login process
      const response = await instance.loginPopup(loginRequest);
      let res;
      // Log the payload of the token request
      let reqBody = {
        token: response.accessToken,
        provider: 'microsoft',
      };
      if (response) {
        res = await userLoginRequest(reqBody);
      }
      const { isSuccess, statusCode } = res?.data || {};
      const isValidStatus = isSuccess && statusCode === 200;
      if (isValidStatus) {
        handleStoreLoginInfo(res);
      }
    } catch (error) {}
  };

  return (
    <>
      <Grid className="main-sign">
        <form onSubmit={handleSubmit}>
          <Grid container className="sign-in">
            <Grid item sx={{ display: 'flex', flexDirection: 'column' }}>
              <Typography variant="h7" align="center" color="#040F3E" sx={{ textTransform: 'none' }}>
                Please sign in to Service Avenger
              </Typography>
              <Typography variant="h7" align="center" color="#040F3E" sx={{ textTransform: 'none' }}>
                to Continue.
              </Typography>
            </Grid>

            <Grid
              container
              sx={{
                display: 'flex',
                justifyContent: 'center',
                flexDirection: 'column',
                marginTop: '5px',
              }}
              spacing={1}
            >
              <Grid
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  marginLeft: '8px',
                }}
              >
                <Grid item xs={12} sm={12}>
                  <StyledTextField
                    size="small"
                    fullWidth
                    name="email"
                    label="Your Email Address"
                    onChange={(e) => handleEmailChange(e)}
                    value={values.email}
                    onBlur={(e) => {
                      handleBlur(e);
                      if (Object.keys(errors).length === 0) {
                        handleAccountInfo();
                      } else {
                        handleAccountInfo();
                      }
                    }}
                    error={Boolean(touched.email && errors.email)}
                  />
                  {Boolean(touched.email && errors.email) && (
                    <Typography variant="body2" color="error">
                      {errors.email}
                    </Typography>
                  )}
                </Grid>
                {loader &&
                  (isEmailVerified ? (
                    <Grid sx={{ marginLeft: '10px' }}>
                      <img src={TickIcon} alt="icon" />
                    </Grid>
                  ) : (
                    <CircularProgress size={30} sx={{ color: 'green', marginLeft: '10px' }} />
                  ))}
              </Grid>

              <Grid item sm={12} xs={12} sx={{ marginTop: '10px', marginBottom: '5px' }}>
                <FormControl fullWidth>
                  <InputLabel
                    htmlFor="password"
                    sx={{
                      '&.MuiInputLabel-root': {
                        top: '-5px',
                      },
                    }}
                  >
                    {
                      <span
                        style={{
                          padding: 0,
                          margin: 0,
                          textAlign: 'center',
                          color: '#AEB5BC',
                        }}
                      >
                        Password
                      </span>
                    }
                  </InputLabel>

                  <OutlinedInput
                    sx={{
                      backgroundColor: '#F9F9F9',
                      border: '1px solid #F9F9F9',

                      '&.MuiOutlinedInput-root.Mui-disabled': {
                        border: '1px solid #F9F9F9',
                      },
                      '&.MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline ': {
                        border: '1px solid #F9F9F9',
                      },
                    }}
                    disabled={isDisabled}
                    size="small"
                    id="password"
                    name="password"
                    type={showPassword ? 'text' : 'password'}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    }
                    onChange={(e) => {
                      setFieldValue('password', e.target.value);
                    }}
                    onBlur={handleBlur}
                    label="Password"
                    error={Boolean(touched.password && errors.password)}
                  />
                  {Boolean(touched.password && errors.password) && (
                    <Typography variant="body2" color="error">
                      {errors.password}
                    </Typography>
                  )}
                </FormControl>
              </Grid>

              {alreadyExit && (
                <Grid
                  item
                  sx={{
                    display: 'flex',
                    justifyContent: 'end',
                    alignItems: 'center',
                  }}
                >
                  <Button
                    disableElevation
                    disableRipple
                    sx={{
                      color: ' #02A0FC',
                      textTransform: 'none',
                      cursor: 'pointer',
                      '&.MuiButton-root:hover': {
                        backgroundColor: '#FFF',
                      },
                      padding: 0,
                      margin: 0,
                    }}
                    onMouseEnter={(e) => (e.target.style.textDecoration = 'underline')}
                    onMouseLeave={(e) => (e.target.style.textDecoration = 'none')}
                    onClick={handleOnCLickOnForgetPassword}
                  >
                    Forgot Password?
                  </Button>
                </Grid>
              )}

              <Grid item sx={{ display: 'flex', alignItems: 'center' }}>
                <Checkbox
                  sx={{ padding: '9px 9px 9px 0px', color: '#757C80' }}
                  id="account.self-dealer"
                  name="account.isSelfServicingDealer"
                  defaultChecked
                  onChange={handleOnChange}
                />

                <Typography
                  variant="caption"
                  sx={{
                    marginTop: '5px',
                    color: 'rgba(0, 0, 0, 0.6)',
                    textTransform: 'none',
                  }}
                >
                  I give consent to OPW to use my phone and email to contact me for dispatch related tasks.
                </Typography>
              </Grid>
            </Grid>

            <Grid
              container
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                marginTop: '0px',
              }}
              spacing={2}
            >
              <Grid item style={{ marginTop: '0.2rem' }}>
                <Button
                  variant="contained"
                  type="submit"
                  sx={{ textTransform: 'none' }}
                  disabled={isChecked ? true : false || onceClicked}
                >
                  Login
                </Button>
              </Grid>
              <Grid item style={{ marginTop: '0.2rem' }}>
                <Button
                  onClick={() => {
                    microsoftLogin();
                  }}
                  variant="outlined"
                  sx={{ textTransform: 'none' }}
                >
                  Sign In With Microsoft
                </Button>
              </Grid>
            </Grid>

            <Grid
              container
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                marginTop: '0px',
              }}
              spacing={2}
            >
              <Grid item>
                <Typography variant="caption" sx={{ marginTop: '5px', color: 'rgba(0, 0, 0, 0.6)' }}>
                  Don't have an account yet ?
                  <Link
                    style={{
                      color: ' #02A0FC',
                      textDecoration: 'none',
                      cursor: 'pointer',
                      marginLeft: '5px',
                    }}
                    onMouseEnter={(e) => (e.target.style.textDecoration = 'underline')}
                    onMouseLeave={(e) => (e.target.style.textDecoration = 'none')}
                  >
                    Create Account
                  </Link>
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </form>
      </Grid>
    </>
  );
};
export default SignIn;
